import React, { ChangeEvent } from 'react';
import { Control, useController } from 'react-hook-form';
import { ProfileEducationFormVO } from '@domain/vo/profile/ProfileEducationFormVO';

import classnames from 'classnames/bind';
import styles from '../edu.module.scss';

const cx = classnames.bind(styles);

const maxLength = 1000;

interface ResearchesDescriptionProps {
  control: Control<ProfileEducationFormVO>;
  defaultValue?: string;
  index: number;
}

const ResearchesDescription = ({ control, defaultValue, index }: ResearchesDescriptionProps) => {
  const { field: descriptionField } = useController({
    control,
    defaultValue,
    name: `profileResearches.${index}.description`,
  });

  const length = descriptionField.value?.length ?? 0;

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) return;
    descriptionField.onChange(e.target.value);
  };

  return (
    <div className={cx('textareaWrap')}>
      <textarea
        {...descriptionField}
        placeholder="연구 분야를 간략하게 설명해주세요."
        maxLength={maxLength}
        rows={4}
        onChange={onChange}
      />
      <div className={cx('infoText')}>
        최대 글자수 : <span className={cx('value')}>{length}</span> / {maxLength}
      </div>
    </div>
  );
};

export default ResearchesDescription;
